
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type boughtTogetherRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function boughtTogetherRT(): TemplateResult<boughtTogetherRTRootProps> {
    function mergeProps(inline, external) {
        var res = Object.assign({}, inline, external);
        if (inline.hasOwnProperty('style')) {
            res.style = _.defaults(res.style, inline.style);
        }
        if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
            res.className = external.className + ' ' + inline.className;
        }
        return res;
    }
    function repeatItems2(mainProduct, items, itemsIndex) {
        return [items(function () {
                function mergeProps(inline, external) {
                    var res = Object.assign({}, inline, external);
                    if (inline.hasOwnProperty('style')) {
                        res.style = _.defaults(res.style, inline.style);
                    }
                    if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                        res.className = external.className + ' ' + inline.className;
                    }
                    return res;
                }
                function repeatBadge2(badge, badgeIndex) {
                    return _createElement('span', {
                        'className': 'badge badge--bottom-left color-accent-1',
                        'key': badge
                    }, '\n                  ', _translate(`product_badge_${ badge }`) || badge, '\n                ');
                }
                function scopeDiscount3() {
                    var discount = this.calcDiscount(this.price, this.compare_at_price);
                    return _createElement('div', { 'className': 'price' + (this.on_sale ? ' price--on-sale' : '') }, _createElement('div', { 'className': 'price__container' }, !this.on_sale ? _createElement('div', {
                        'className': 'price__regular',
                        'key': '3505'
                    }, _createElement('span', { 'className': 'price-item price-item--regular' }, this.formatPrice(this.price))) : null, this.on_sale ? _createElement('div', {
                        'className': 'price__sale',
                        'key': '3708'
                    }, _createElement('span', { 'className': 'price-item price-item--last price-item--sale' }, '\n                        ', this.formatPrice(this.price), '\n                      '), _createElement('span', { 'className': 'price-item price-item--regular' }, '\n                         ', _createElement('del', {}, this.formatPrice(this.compare_at_price)))) : null), this.on_sale && discount > 0 ? _createElement('div', {
                        'className': 'cm_sale-percent',
                        'key': '4177'
                    }, '-', discount, '%') : null);
                }
                return this.id != window.Convermax.Shopify.productId ? _createElement('div', {
                    'onClick': this.selectItem,
                    'className': 'card-wrapper product-card-wrapper' + (this.isSelected ? ' cm_selected' : ''),
                    'key': '7'
                }, _createElement('div', { 'className': 'cm_checkbox' }, !this.isSelected ? [_createElement('svg', {
                        'className': 'cm_unchecked',
                        'width': '1.6rem',
                        'height': '1.6rem',
                        'viewBox': '0 0 16 16',
                        'aria-hidden': 'true',
                        'focusable': 'false',
                        'key': '2400'
                    }, _createElement('rect', {
                        'x': '1',
                        'y': '1',
                        'width': '14',
                        'height': '14',
                        'stroke': 'currentColor',
                        'fill': 'none',
                        'strokeWidth': '1',
                        'vectorEffect': 'non-scaling-stroke'
                    }))] : null, this.isSelected ? [_createElement('svg', {
                        'className': 'cm_checked icon icon-checkmark',
                        'aria-hidden': 'true',
                        'xmlns': 'http://www.w3.org/2000/svg',
                        'width': '22',
                        'height': '23',
                        'viewBox': '0 0 22 23',
                        'fill': 'none',
                        'key': '5520'
                    }, _createElement('path', {
                        'd': 'M18.3327 5.82227L8.24935 15.9056L3.66602 11.3223',
                        'stroke': 'white',
                        'strokeWidth': '1.3',
                        'strokeLinecap': 'round',
                        'strokeLinejoin': 'round'
                    }))] : null), _createElement('div', { 'className': 'card card--standard card--media' }, _createElement('div', { 'className': 'card__inner color-accent-1 gradient ratio' }, _createElement('div', { 'className': 'card__media' }, _createElement('div', { 'className': 'media media--transparent media--hover-effect' }, _createElement('img', {
                    'className': 'motion-reduce',
                    'src': this.imageOrDefault(this.resizeImage(this.image)),
                    'alt': this.removeHTML(this.title),
                    'onError': this.onImageError
                }))), _createElement('div', { 'className': 'card__content' }, _createElement('div', { 'className': 'card__information' }, _createElement('h3', { 'className': 'card__heading' }, _createElement('a', mergeProps({ 'className': 'card-link' }, { dangerouslySetInnerHTML: { __html: typeof this.title === 'undefined' ? '' : this.title } })))), _createElement.apply(this, [
                    'div',
                    { 'className': 'card__badge top left' },
                    this.on_sale ? _createElement('span', {
                        'className': 'badge badge--bottom-left color-accent-1',
                        'key': '1762'
                    }, '\n                  ', _translate(`product_sale_badge`), '\n                ') : null,
                    this.product_badges ? _map(this.product_badges, repeatBadge2.bind(this)) : null
                ])), _createElement('a', mergeProps({ 'className': 'card-link card-link-custom' }, { dangerouslySetInnerHTML: { __html: typeof this.title === 'undefined' ? '' : this.title } }))), _createElement('div', { 'className': 'card__content' }, _createElement('div', { 'className': 'card__information' }, _createElement('div', { 'className': 'card__top--infor' }, _createElement('div', mergeProps({ 'className': 'card__vendor' }, { dangerouslySetInnerHTML: { __html: typeof this.vendor === 'undefined' ? '' : this.vendor } })), this.sku ? _createElement('div', {
                    'className': 'card__sku',
                    'key': '2705'
                }, _createElement('span', {}, 'Sku:'), _createElement('span', { dangerouslySetInnerHTML: { __html: typeof this.sku === 'undefined' ? '' : this.sku } })) : null), _createElement('h3', { 'className': 'card__heading h5' }, _createElement('a', mergeProps({
                    'href': this.url,
                    'className': 'card-link'
                }, { dangerouslySetInnerHTML: { __html: typeof this.title === 'undefined' ? '' : this.title } }))), _createElement('div', { 'className': 'card-information' }, scopeDiscount3.apply(this, []), _createElement('div', { 'className': 'card__vendor card__vendor--mobile' }, _createElement('div', { 'className': 'card_vendor--image' }, this.vendor_image ? [_createElement('img', {
                        'src': this.vendor_image,
                        'onError': this.onImageError,
                        'alt': this.removeHTML(this.vendor),
                        'loading': 'lazy',
                        'className': 'product-desc-image',
                        'key': '44311'
                    })] : null, !this.vendor_image ? [_createElement('span', { 'key': '46671' }, this.vendor)] : null))))), _createElement('div', { 'className': 'card__content--status' }, _createElement('div', { 'className': 'card-info-status__product' }, this.rocket_procduct_pendiente ? [
                    _createElement('span', {
                        'className': 'icon',
                        'key': '50071'
                    }, [_createElement('svg', {
                            'xmlns': 'http://www.w3.org/2000/svg',
                            'width': '14',
                            'height': '14',
                            'viewBox': '0 0 14 14',
                            'fill': 'none',
                            'key': '51130'
                        }, _createElement('path', {
                            'd': 'M7 3.5V7L9.33333 8.16667',
                            'stroke': '#ECB621',
                            'strokeWidth': '1.5',
                            'strokeLinecap': 'round',
                            'strokeLinejoin': 'round'
                        }), _createElement('path', {
                            'd': 'M9.33261 12.3429C8.28411 12.801 7.12405 12.9405 5.99683 12.7443C4.8696 12.548 3.82499 12.0246 2.99298 11.2391C2.16098 10.4537 1.57834 9.44092 1.31758 8.32685C1.05681 7.21278 1.12944 6.04662 1.52642 4.97351C1.92339 3.9004 2.62719 2.96773 3.55022 2.29158C4.47324 1.61543 5.57473 1.22566 6.7176 1.17078C7.86046 1.1159 8.99423 1.39833 9.9778 1.98292C10.9614 2.56751 11.7513 3.42845 12.2493 4.45858',
                            'stroke': '#ECB621',
                            'strokeWidth': '1.5',
                            'strokeLinecap': 'round',
                            'strokeLinejoin': 'round'
                        }), _createElement('path', {
                            'd': 'M11.6641 6.70801V10.208',
                            'stroke': '#ECB621',
                            'strokeWidth': '1.5',
                            'strokeLinecap': 'round',
                            'strokeLinejoin': 'round'
                        }), _createElement('path', {
                            'd': 'M11.6641 12.542H11.6707',
                            'stroke': '#ECB621',
                            'strokeWidth': '1.5',
                            'strokeLinecap': 'round',
                            'strokeLinejoin': 'round'
                        }))]),
                    _createElement('span', {
                        'className': 'text',
                        'key': '50073'
                    }, _translate(`product_stock_pending`))
                ] : null, !this.rocket_procduct_pendiente ? [
                    !this.out_of_stock ? [
                        _createElement('span', {
                            'className': 'icon',
                            'key': '63011'
                        }, [_createElement('svg', {
                                'xmlns': 'http://www.w3.org/2000/svg',
                                'width': '16',
                                'height': '16',
                                'viewBox': '0 0 16 16',
                                'fill': 'none',
                                'key': '63990'
                            }, _createElement('path', {
                                'd': 'M13.3008 4.5498L6.42578 11.4248L3.30078 8.2998',
                                'stroke': '#0CB73F',
                                'strokeWidth': '1.5',
                                'strokeLinecap': 'round',
                                'strokeLinejoin': 'round'
                            }))]),
                        _createElement('span', {
                            'className': 'text',
                            'key': '63013'
                        }, _translate(`product_stock_available`))
                    ] : null,
                    this.out_of_stock ? [
                        _createElement('span', {
                            'className': 'icon',
                            'key': '68261'
                        }, [_createElement('svg', {
                                'xmlns': 'http://www.w3.org/2000/svg',
                                'width': '14',
                                'height': '14',
                                'viewBox': '0 0 14 14',
                                'fill': 'none',
                                'key': '69230'
                            }, _createElement('path', {
                                'd': 'M10.5 3.5L3.5 10.5',
                                'stroke': '#EF4A4A',
                                'strokeWidth': '1.5',
                                'strokeLinecap': 'round',
                                'strokeLinejoin': 'round'
                            }), _createElement('path', {
                                'd': 'M3.5 3.5L10.5 10.5',
                                'stroke': '#EF4A4A',
                                'strokeWidth': '1.5',
                                'strokeLinecap': 'round',
                                'strokeLinejoin': 'round'
                            }))]),
                        _createElement('span', {
                            'className': 'text',
                            'key': '68263'
                        }, _translate(`product_out_of_stock`))
                    ] : null
                ] : null), this.option_Color?.length > 1 ? _createElement('div', {
                    'className': 'card-info-status__color',
                    'key': '7475'
                }, _createElement('a', { 'href': this.url }, _createElement('span', { 'className': 'text' }, '+ ', _translate(`product_options`)))) : null))) : null;
            }, { count: undefined })];
    }
    function scopeMainProduct3() {
        var mainProduct = document.getElementById('cm-bought-together-products')?.dataset;
        return _createElement('div', { 'className': 'cm_bought-together' }, _createElement('div', { 'className': 'cm_bought-together-title-container section-rocket-products-related__container' }, _createElement('div', { 'className': 'section-rocket-products-related__heading page-width' }, _createElement('h3', {}, _translate(`bought_together_title`)))), _createElement('div', { 'className': 'cm_bought-together-row' }, _createElement('div', { 'className': 'cm-main-product-container' }, _createElement('span', mergeProps({ 'className': 'card-title' }, { dangerouslySetInnerHTML: { __html: typeof mainProduct?.productTitle === 'undefined' ? '' : mainProduct?.productTitle } })), _createElement('img', {
            'src': mainProduct?.productImage,
            'alt': mainProduct?.productTitle
        })), _createElement('div', { 'className': 'cm-plus-icon' }, _createElement('svg', {
            'xmlns': 'http://www.w3.org/2000/svg',
            'width': '62',
            'height': '62',
            'viewBox': '0 0 62 62',
            'fill': 'none'
        }, _createElement('line', {
            'x1': '31.2988',
            'y1': '15.0371',
            'x2': '31.2988',
            'y2': '48.0371',
            'stroke': 'black',
            'stroke-width': '2'
        }), _createElement('line', {
            'x1': '47.2988',
            'y1': '32.0371',
            'x2': '14.2988',
            'y2': '32.0371',
            'stroke': 'black',
            'stroke-width': '2'
        }))), _createElement.apply(this, [
            'div',
            { 'className': 'cm_bought-together-list cmRepeater_items' },
            _map(this.items, repeatItems2.bind(this, mainProduct))
        ])), this.totalPrice ? _createElement('div', {
            'className': 'cm_bought-together_buttons-container',
            'key': '13458'
        }, _createElement('div', { 'className': 'cm_bought-together_buttons' }, _createElement('div', { 'className': 'cm_bought-together_total-price' }, _createElement('span', { 'className': 'cm_total-price' }, this.totalPrice)), _createElement('div', { 'className': 'cm_bought-together_button-container' }, _createElement('button', {
            'onClick': this.addItemsToCart,
            'className': 'cm_bought-together_button cm_button cm_button__primary'
        }, '\n          ', _translate(`bought_together_button_text`), '\n        ')))) : null);
    }
    return scopeMainProduct3.apply(this, []);
}
        export const componentNames = []